var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ActionCombo,{attrs:{"noBorder":_vm.noBorder,"noClearable":_vm.noClearable,"placeholder":_vm.placeholder,"skeleton":_setup.compSkeleton,"disabled":_setup.compDisabled,"rules":_vm.rules,"items":_setup.items.list},model:{value:(_setup.dvalue),callback:function ($$v) {_setup.dvalue=$$v},expression:"dvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }